import { SpecialEventValueTypes, IncludesFilterOptions } from "../SpecialEventsQuery/SpecialEventsQuery.consts";
import { ASSISTANT_CHANNELS } from "src/utils/core/consts";

export const ConversationExperienceOptions = {
  LONG_SILENCE: "LONG_SILENCE",
  SENTIMENT: "SENTIMENT",
  USER_FEEDBACK: "USER_FEEDBACK"
};

export const SentimentValues = {
  ANY: { key: "ANY", label: "Any" },
  GOOD: { key: "GOOD", label: "Good" },
  NEEDS_IMPROVEMENT: { key: "NEEDS_IMPROVEMENT", label: "Needs Improvement" }
};

export const UserFeedbackValues = {
  POSITIVE: { key: "POSITIVE", label: "Positive" },
  NEGATIVE: { key: "NEGATIVE", label: "Negative" },
  ANY: { key: "ANY", label: "Any" }
};

const BaseConversationExperienceAttributes = {
  [ConversationExperienceOptions.LONG_SILENCE]: {
    type: "LONG_SILENCE",
    label: "Long Silence",
    valueType: SpecialEventValueTypes.BOOLEAN_INCLUDED
  },
  [ConversationExperienceOptions.SENTIMENT]: {
    type: "SENTIMENT",
    label: "Sentiment",
    valueType: SpecialEventValueTypes.STATIC_DROPDOWN,
    placeholder: "Select sentiment",
    valueOptions: Object.values(SentimentValues)
  }
};

const UserFeedbackAttribute = {
  [ConversationExperienceOptions.USER_FEEDBACK]: {
    type: "USER_FEEDBACK",
    label: "User Feedback",
    valueType: SpecialEventValueTypes.STATIC_DROPDOWN_INCLUDED,
    placeholder: "Select feedback",
    valueOptions: Object.values(UserFeedbackValues),
    defaultFilter: IncludesFilterOptions.INCLUDES.key
  }
};

export const ConversationExperienceAttributes = {
  ...BaseConversationExperienceAttributes,
  ...UserFeedbackAttribute
};

export const getConversationExperienceAttributes = ({ channel }) =>
  channel === ASSISTANT_CHANNELS.WEB
    ? ConversationExperienceAttributes
    : BaseConversationExperienceAttributes;
